import React from 'react';
import { Steps, createSteps, updateStepStatus } from '@/components/ui';
import { useNotificationStore } from '@/stores/notificationStore';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function StepsSection() {
  const notifySuccess = useNotificationStore(s => s.success);

  return (
    <SectionWrapper title="Steps Component">
        <div>
          <h3 className="text-lg font-semibold mb-4">Basic Usage</h3>
          <div className="space-y-6">
            <div>
              <p className="text-sm text-muted-foreground mb-3">Default horizontal steps</p>
              <Steps
                steps={updateStepStatus(createSteps(['Upload', 'Process', 'Review', 'Import', 'Complete']), 2)}
                showLabels={true}
                size="md"
              />
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-3">Responsive (desktop shows full, mobile shows compact)</p>
              <Steps
                steps={updateStepStatus(createSteps(['Upload File', 'AI Processing', 'Review Data', 'Import to Database', 'Complete']), 1)}
                responsive={true}
                showLabels={true}
                size="md"
              />
            </div>
          </div>
          <CodeBlock>
{`import { Steps, createSteps, updateStepStatus } from '@/components/ui';

const steps = updateStepStatus(
  createSteps(['Upload', 'Process', 'Review', 'Import', 'Complete']),
  2 // Current step index (0-based)
);

<Steps
  steps={steps}
  responsive={true}
  showLabels={true}
  size="md"
/>`}
          </CodeBlock>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Sizes</h3>
          <div className="space-y-6">
            <div>
              <p className="text-sm text-muted-foreground mb-2">Small</p>
              <Steps
                steps={updateStepStatus(createSteps(['Step 1', 'Step 2', 'Step 3']), 1)}
                size="sm"
                showLabels={true}
              />
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Medium (default)</p>
              <Steps
                steps={updateStepStatus(createSteps(['Step 1', 'Step 2', 'Step 3']), 1)}
                size="md"
                showLabels={true}
              />
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Large</p>
              <Steps
                steps={updateStepStatus(createSteps(['Step 1', 'Step 2', 'Step 3']), 1)}
                size="lg"
                showLabels={true}
              />
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Vertical Orientation</h3>
          <div className="max-w-xs">
            <Steps
              steps={updateStepStatus(createSteps(['Create Account', 'Verify Email', 'Setup Profile', 'Complete']), 2)}
              orientation="vertical"
              showLabels={true}
              showDescriptions={false}
              size="md"
            />
          </div>
          <CodeBlock>
{`<Steps
  steps={steps}
  orientation="vertical"
  showLabels={true}
  size="md"
/>`}
          </CodeBlock>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Interactive Steps</h3>
          <Steps
            steps={updateStepStatus(createSteps(['Configure', 'Deploy', 'Test', 'Launch']), 1)}
            showLabels={true}
            size="md"
            onStepClick={(step, index) => {
              notifySuccess(`Clicked step ${index + 1}: ${step.label}`);
            }}
          />
          <CodeBlock>
{`<Steps
  steps={steps}
  showLabels={true}
  onStepClick={(step, index) => {
    // Handle step click
    console.log('Clicked step:', index + 1, step.label);
  }}
/>`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
